export default __webpack_public_path__ + "static/media/buscar.7024a893.png";